import { jsx as _jsx } from "react/jsx-runtime";
import { useStyleConfig, vui } from '../core';
import T from '../t';
import { cs } from '../utils';
import { usePaginationContext } from './context';
/** Displays an action button within the Pagination. */
export const PaginationResults = vui((props, ref) => {
    const { children, className, ...rest } = props;
    const { count, rangeEnd, rangeStart } = usePaginationContext();
    const styles = useStyleConfig('Pagination', usePaginationContext());
    return (_jsx(T, { className: cs('vui-paginationResults', className), ref: ref, size: "sm", ...styles.results, ...rest, children: children ?? `Showing ${rangeStart} to ${rangeEnd} of ${count} results.` }));
});
PaginationResults.displayName = 'PaginationResults';
export default PaginationResults;
